// https://github.com/sidestream-tech/hanselmann-os/pull/2868
export default function (quantity: number, packagingLotSize: number) {
  return quantity * packagingLotSize
}
